<template>
    <el-card>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
                >Panel</el-breadcrumb-item
            >
            <el-breadcrumb-item>Notificaciones</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <div
            class="loading"
            v-loading="true"
            v-if="fecthItems.length === 0"
        ></div>
        <template v-else>
            <app-modal-draggable
                v-if="modalDraggable"
                :content="tableQuery"
                :name="'title'"
                :table="'desktop'"
            ></app-modal-draggable>
            <app-table-paginate
                :routeEdit="routeEdit"
                :tableQuery="fecthItems"
                :tableColumns="tableColumns"
                :preview="preview"
                :limit="limit"
                :draggable="true"
                :search="true"
            ></app-table-paginate>
            <br />
            <br />
            <br />
            <el-button type="primary" size="medium" @click="nuevoRegistro()">
                Nuevo
                <i class="el-icon-circle-plus-outline el-icon-right"></i>
            </el-button>
        </template>
    </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { INTRANET_URL } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_TEMPLATE_DESKTOP } from "@/store/actions.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Draggable from "@/components/Dashboard/Modals/draggable";
import moment from "moment-timezone";

export default {
    name: "NotificacionesList",
    components: {
        "app-table-paginate": tablaConPaginador,
        "app-modal-draggable": Draggable
    },
    async created() {
        this.routeEdit =
            "/dashboard/" +
            this.$route.params.db +
            "/notificaciones_periodicas/edit/";
        this.init();
        this.$root.$on("delete", id => {
            this.eliminarRegistro(id);
        });
    },

    data() {
        return {
            tableColumns: [
                {
                    prop: "dia",
                    label: "Repetir el día de cada mes"
                },
                {
                    prop: "asunto",
                    label: "Asunto"
                },
                {
                    prop: "activo",
                    label: "Activo",
                    type: "switch"
                }
            ],
            tableQuery: {},
            searchQuery: "",
            routeEdit: null,
            deleterow: false,
            preview: null,
            templates: false,
            modalDraggable: false,
            limit: 10,
            access: []
        };
    },
    watch: {
        $route(to) {
            this.routeEdit =
                "/dashboard/" +
                this.$route.params.db +
                "/nomina/form/edit/" +
                this.$route.params.table +
                "/";
            this.init();
        }
    },
    methods: {
        async init() {
            await this.getPages();
        },
        nuevoRegistro() {
            this.$router.push(
                "/dashboard/" +
                    this.$route.params.db +
                    "/notificaciones_periodicas/new"
            );
        },

        async getPages() {
            this.tableQuery = [];
            const a = await ApiService.post("dashboard/table", {
                table: "notificaciones_cron",
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table")
            });
            if (a.data != "Algo ha fallado") {
                a.data.forEach(element => {
                    this.tableQuery.push(element);
                });
            } else {
                this.tableQuery = {};
            }
        },
        async eliminarRegistro(id) {
            await ApiService.post("dashboard/delete", {
                table: "notificaciones_cron_auth",
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table"),
                k1: "notificaciones_cron",
                k1id: id,
                k2: "notificaciones_cron",
                k2id: id
            });

            await ApiService.post("dashboard/delete", {
                table: "notificaciones_cron",
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table"),
                id: id
            }).then(response => {
                this.deleterow = response.data;

                if (this.deleterow == 1) {
                    this.$message({
                        type: "success",
                        message: "Se ha eliminado correctamente"
                    });
                    this.getPages();
                } else {
                    this.$message({
                        type: "warning",
                        message: this.deleterow
                    });
                }
            });
        },
        showDraggable() {
            this.modalDraggable = true;
        },
        closeModal() {
            this.modalDraggable = false;
            this.init();
        }
    },
    computed: {
        fecthItems() {
            return this.tableQuery;
        },
        ...mapGetters(["userAccessPlugins"])
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/notificaciones_cron/list.vue